module.exports = __webpack_public_path__ + "img/audio-resource.svg";